import { withoutSpace } from '../helpers.js';

const conditionsStr = "_chinese,_ariaInvalid,_on,_hover,_focus,_focusWithin,_focusVisible,_disabled,_active,_visited,_target,_readOnly,_readWrite,_empty,_checked,_enabled,_expanded,_highlighted,_complete,_incomplete,_dragging,_before,_after,_firstLetter,_firstLine,_marker,_selection,_file,_backdrop,_first,_last,_only,_even,_odd,_firstOfType,_lastOfType,_onlyOfType,_peerFocus,_peerHover,_peerActive,_peerFocusWithin,_peerFocusVisible,_peerDisabled,_peerChecked,_peerInvalid,_peerExpanded,_peerPlaceholderShown,_groupFocus,_groupHover,_groupActive,_groupFocusWithin,_groupFocusVisible,_groupDisabled,_groupChecked,_groupExpanded,_groupInvalid,_indeterminate,_required,_valid,_invalid,_autofill,_inRange,_outOfRange,_placeholder,_placeholderShown,_pressed,_selected,_grabbed,_underValue,_overValue,_atValue,_default,_optional,_open,_closed,_fullscreen,_loading,_hidden,_current,_currentPage,_currentStep,_today,_unavailable,_rangeStart,_rangeEnd,_now,_topmost,_motionReduce,_motionSafe,_print,_landscape,_portrait,_dark,_light,_osDark,_osLight,_highContrast,_lessContrast,_moreContrast,_ltr,_rtl,_scrollbar,_scrollbarThumb,_scrollbarTrack,_horizontal,_vertical,_icon,_starting,_noscript,_invertedColors,mobile,mobileOnly,mobileDown,mobileWide,mobileWideOnly,mobileWideDown,tablet,tabletOnly,tabletDown,tabletWide,tabletWideOnly,tabletWideDown,desktop,desktopOnly,desktopDown,wide,wideOnly,wideDown,ultraWide,ultraWideOnly,ultraWideDown,mobileToMobileWide,mobileToTablet,mobileToTabletWide,mobileToDesktop,mobileToWide,mobileToUltraWide,mobileWideToTablet,mobileWideToTabletWide,mobileWideToDesktop,mobileWideToWide,mobileWideToUltraWide,tabletToTabletWide,tabletToDesktop,tabletToWide,tabletToUltraWide,tabletWideToDesktop,tabletWideToWide,tabletWideToUltraWide,desktopToWide,desktopToUltraWide,wideToUltraWide,@/mobile,@/mobileWide,@/tablet,@/tabletWide,@/desktop,@/wide,@/ultraWide,base"
const conditions = new Set(conditionsStr.split(','))

const conditionRegex = /^@|&|&$/

export function isCondition(value){
  return conditions.has(value) || conditionRegex.test(value)
}

const underscoreRegex = /^_/
const conditionsSelectorRegex = /&|@/

export function finalizeConditions(paths){
  return paths.map((path) => {
    if (conditions.has(path)){
      return path.replace(underscoreRegex, '')
    }

    if (conditionsSelectorRegex.test(path)){
      return `[${withoutSpace(path.trim())}]`
    }

    return path
  })}

  export function sortConditions(paths){
    return paths.sort((a, b) => {
      const aa = isCondition(a)
      const bb = isCondition(b)
      if (aa && !bb) return 1
      if (!aa && bb) return -1
      return 0
    })
  }